export default __webpack_public_path__ + "static/media/line-qrcode.930dc7c0.png";